import React from 'react';
import PropTypes from 'prop-types';

const DeleteIcon = ({ width, height, fill }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 14 14">
    <g>
        <path d="M8.663 7l4.987 4.988a1.176 1.176 0 01-1.662 1.662L7 8.663 2.012 13.65A1.176 1.176 0 01.35 11.988L5.338 7 .35 2.012A1.176 1.176 0 012.012.35L7 5.338 11.988.35a1.176 1.176 0 111.662 1.662z" fill={fill} fillRule="evenodd" />
    </g>
</svg>
);

DeleteIcon.propTypes = {
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    fill: PropTypes.string
};

DeleteIcon.defaultProps = {
    width: '14',
    height: '14',
    fill: '#4b254e'
};

export default DeleteIcon;
